// extracted by mini-css-extract-plugin
module.exports = {"column":"style_column__2Zqki","align-right":"style_align-right__1rn5G","flexable":"style_flexable__3kay7"};